
export default class MapObj {
	constructor(map) {
		this.TMap = map;
		this.inst = null;
		this.markerLayer = null;
		this.geocoder = null; //new TMap.service.Geocoder(); // 新建一个正逆地址解析类
	}

	initMap(elemId, zoom, centerLng, centerLat) {
		if (this.inst) return;
		this.inst = new this.TMap.Map(elemId, {
			center: new this.TMap.LatLng(centerLat, centerLng),
			zoom: zoom,
			pitch: 0,
			rotation: 0
		});

		//初始化marker图层
		this.markerLayer = new this.TMap.MultiMarker({
			id: 'marker-layer',
			map: this.inst
		});
		return this.inst;
	}

	destroyMap() {
		if (!this.inst) return;
		this.markerLayer.setGeometries([]);
		this.inst.destroy();
		this.inst = null;
	}

	createMarker(markerId, longitude, latitude) {
		// const marker = new this.TMap.Marker({
		// 	position: new this.TMap.LatLng(latitude, longitude),
		// 	map: this.inst
		// });
		let options = {
			position: new this.TMap.LatLng(latitude, longitude)
		};
		if (markerId) {
			options.id = markerId
		}
		const marker = this.markerLayer.add(options);
		return;
	}

	removeMarker(marker) {
		this.markerLayer.remove([marker]);
	}

	setMarkerPosition(markerId, longitude, latitude) {
		this.markerLayer.updateGeometries([{
			id: markerId,
			position: new this.TMap.LatLng(latitude, longitude)
		}]);
	}

	setCenter(longitude, latitude) {
		this.inst.setCenter(new this.TMap.LatLng(latitude, longitude));
	}

	on(evt, callback) {
		this.inst.on(evt, callback);
	}

	geoCoder(address) {
		const _this = this;
		if (!this.geocoder) this.geocoder = new this.TMap.service.Geocoder();
		const p = new Promise(function(resolve, reject) {
			// 将给定的地址转换为坐标位置
			_this.geocoder.getLocation({
					address: address
				})
				.then((result) => {
					resolve(result);
				}).catch(err => {
					reject(err);
				});
		});
		return p;
	}
}